import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useToken } from "src/business-hooks/useToken";
import useBooleanState from "src/hooks/useBooleanState";
import GenerateTokenForm from "../GenerateTokenForm/GenerateTokenForm";
import { READ_ONLY_TOKENS_MESSAGE } from "../SystemSettingsTokenManagement/SystemSettingsTokenManagement.constants";

export default function SystemSettingsTokenManagementFooter() {
  const { visible, show, hide } = useBooleanState(false);
  const { loggedInUser } = useToken();
  const isReadOnly = !!loggedInUser?.read_only;

  return (
    <>
      <footer className="flex items-center p-6">
        <Tooltip title={isReadOnly ? READ_ONLY_TOKENS_MESSAGE : ""}>
          {/* span: a disabled button fires no events, so the tooltip needs a wrapper */}
          <span>
            <Button
              variant="outlined"
              onClick={show}
              disabled={isReadOnly}
              data-test-id="generate-token-button"
            >
              Generate Token
            </Button>
          </span>
        </Tooltip>
      </footer>
      <GenerateTokenForm open={visible} onClose={hide} />
    </>
  );
}
